export const moneyMask = (text: string) => {
    const currency = JSON.parse(localStorage.getItem(`@currency`) || '{}') as { code: string; symbol: string; };

    const value = text.replace(/\D/g, '');
    const number = parseInt(value || '0', 10).toString();

    const formatted =
    number.length > 2
        ? number.slice(0, -2) + ',' + number.slice(-2)
        : number.length === 2
        ? '0,' + number
        : '0,0' + number;

    return `${currency?.symbol ?? "R$"} ${formatted}`;
};

interface ICurrencyProps {
  decimals?: number;
  showSymbol?: boolean;
};

export function moneyMaskNumber(
  value: number,
  { decimals = 2, showSymbol = true }: ICurrencyProps = {}
): string {
  const currency = JSON.parse(localStorage.getItem(`@currency`) || '{}') as { code: string; symbol: string; };

  const formatted = new Intl.NumberFormat('pt-BR', {
    style: showSymbol ? 'currency' : 'decimal',
    currency: currency?.code ?? "BRL",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);

  return formatted;
}

export const moneyToFloat = (text: string) => {
    text = text.replace(/[^0-9]/g, "") ;
    text = text ? text: '0';
    return Number.parseFloat(text.replace(/[^0-9]/g, "")) / 100;
}

export const floatMaskNumber = (percent: number) => {
    return `${percent.toFixed(2).replace('.', ',')}%`;
}
export const floatMask = (text: string) => {
    var value = text ? Number.parseInt(text.substr(0, 14).replace(/[^0-9]/g, "")).toString() : "0,00";
    var returnValue: string = value.length > 2 ? value.slice(0, value.length - 2) + "," + value.slice(value.length - 2, value.length) : value.length === 2 ? "0," + value : "0,0" + value;
    return  returnValue;
};

export const textToFloat = (text: string) => {
    text = text.replace(/[^0-9]/g, "");
    text = text ? text : '0';
    return Number.parseFloat(text.replace(/[^0-9]/g, "")) / 100;
};
